module.exports = __webpack_public_path__ + "fonts/HSESans-Bold.2cf8b21.otf";